import { Modal } from "antd-v4";

export default function ExternModal({
    visible,
    width,
    body,
    maskStyle
}) {

    return (
        <Modal
            className="modal-payment"
            open={visible}
            footer={null}
            closable={false}
            width={width}
            bodyStyle={{ padding: 10 }}
            maskStyle={maskStyle}
            centered
        >
            {
                body
            }
        </Modal>
    );
}
